import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getHafHourTimeOption } from "../Time/timeOptions";

const styles = () => {
  return {
    width: "100%",
    "& .progress-bar": {
      position: "relative",
      width: "100%",
      height: "16px",
      border: "2px solid #004562",
      borderRadius: "2px",
      marginBottom: "4px",
      overflow: "hidden",
    },
    "& .progress-fill": {
      position: "absolute",
      height: "13px",
      borderRadius: "2px",
      backgroundColor: "#F9B426",
    },
  };
};

const TimeProgressBar = ({ start, end }) => {
  const startPercentage = (start / 24) * 100;
  const endPercentage = (end / 24) * 100;

  return (
    <Box sx={styles}>
      <Box className="progress-bar">
        {start < end ? (
          <Box
            className="progress-fill"
            style={{
              left: `${startPercentage}%`,
              width: `${endPercentage - startPercentage}%`,
            }}
          ></Box>
        ) : (
          <>
            <Box
              className="progress-fill"
              style={{
                left: `${startPercentage}%`,
                width: `${100 - startPercentage}%`,
              }}
            ></Box>
            <Box
              className="progress-fill"
              style={{
                left: `0%`,
                width: `${endPercentage}%`,
              }}
            ></Box>
          </>
        )}
      </Box>
    </Box>
  );
};

const ChargeBetween = ({ start, end }) => {
  const [chargeBetween, setChargeBetween] = useState("");

  useEffect(() => {
    setChargeBetween(
      `${getHafHourTimeOption(start)} and ${getHafHourTimeOption(end)}`
    );
  }, [start, end]);

  return (
    <Box sx={styles}>
      <TimeProgressBar start={start} end={end} />
      <Typography>Charge between {chargeBetween}</Typography>
    </Box>
  );
};

export default ChargeBetween;
